"use strict";

window.KMUserAddressesFormContainerInit = () => {
  const initBillingDetailsFilledInCheckbox = $form => {
    const $checkbox = $("#km-userAddressesFormContainer-billingAddressCheckbox", $form);
    $checkbox.unbind('change').change(() => {
      const $tbody = $checkbox.closest("tbody");
      const $tr = $checkbox.closest("tr");
      const $elements = $("tr", $tbody).not($tr);
      if ($checkbox.is(":checked")) {
        $elements.show();
      } else {
        $.each($elements, function (index, element) {
          element.setAttribute('style', 'display:none !important');
        });
      }
    }).triggerHandler('change');
  };
  const initDeliveryDetailsFilledInCheckbox = function ($form) {
    const $checkbox = $('#frm-editAddressesForm-editContactForm-userAddresses-deliveryAddress-deliveryDetailsCheckbox,' + '#frm-registrationForm-registrationForm-userAddresses-deliveryAddress-deliveryDetailsCheckbox,' + '#frm-customerDetailSettings-addressForm-userAddresses-deliveryAddress-deliveryDetailsCheckbox').first();
    const autocompleteValuesByIndex = {};
    const $tbody = $checkbox.closest('tbody');
    const $tr = $checkbox.closest('tr');
    const $allRows = $('tr', $tbody);
    const currentIndex = $allRows.index($tr);
    const $elements = $allRows.slice(currentIndex + 1);
    $.each($elements, function (rowIndex, element) {
      $('input', element).each(function (index, input) {
        autocompleteValuesByIndex[rowIndex] = input.getAttribute('autocomplete');
      });
    });
    $checkbox.off('change').on('change', function () {
      if ($checkbox.is(':checked')) {
        $elements.show();
        $.each($elements, function (rowIndex, element) {
          $('input', element).each(function (index, input) {
            input.setAttribute('autocomplete', autocompleteValuesByIndex[rowIndex]);
            input.removeAttribute('readonly');
          });
        });
      } else {
        $.each($elements, function (rowIndex, element) {
          element.setAttribute('style', 'display:none !important');
          $('input', element).each(function (index, input) {
            input.setAttribute('autocomplete', 'off');
            input.setAttribute('readonly', '');
          });
        });
      }
    }).triggerHandler('change');
  };
  const initDynamicPlaceholders = $form => {
    const valToPlaceholder = {
      '#km-contactAddressFormContainer-personName-givenName': '#km-deliveryAddressFormContainer-personName-givenName',
      '#km-contactAddressFormContainer-personName-familyName': '#km-deliveryAddressFormContainer-personName-familyName',
      '#tel-national': '#km-deliveryAddressFormContainer-phoneNumber',
      '#email': '#km-deliveryAddressFormContainer-emailAddress'
    };
    jQuery.each(valToPlaceholder, (from, to) => {
      const $from = $(from, $form);
      const $to = $(to, $form);
      $from.on('change keyup', function () {
        $to.attr('placeholder', $from.val());
      });
      $from.triggerHandler('change');
    });

    // Contact PhoneNumber-CountryPrefix > Delivery PhoneNumber-CountryPrefix
    const countryPrefixFrom = $('#tel-national-countryPrefix', $form);
    const countryPrefixTo = $('#km-deliveryAddressFormContainer-phoneNumber-countryPrefix', $form);
    countryPrefixFrom.on('change', () => {
      countryPrefixTo.val(countryPrefixFrom.val());
    });
    countryPrefixFrom.triggerHandler('change');
  };
  const $form = $('.km-userAddressesFormContainer-form').first();
  if ($form.length === 1) {
    initBillingDetailsFilledInCheckbox($form);
    initDeliveryDetailsFilledInCheckbox($form);
    initDynamicPlaceholders($form);
  }
};
$(document).ready(() => {
  window.KMUserAddressesFormContainerInit();
});